import { render } from "./BaseSelect.vue?vue&type=template&id=1f370a5a"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script